import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-onboarding-page__screen-scroll" }
const _hoisted_2 = { class: "bonusomat-onboarding-page__screen" }
const _hoisted_3 = { class: "bonusomat-onboarding-page__text" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

import WebpImage from "@sazka/design-system/src/image/webp-image.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-onboarding-page',
  props: {
    codeName: {},
    image: {},
    title: {},
    description: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bonusomat-onboarding-page__device", _ctx.codeName])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(WebpImage, {
          class: "bonusomat-onboarding-page__image-wrapper",
          "css-class": "bonusomat-onboarding-page__image",
          src: _ctx.image,
          alt: _ctx.title,
          get2x: true
        }, null, 8, ["src", "alt"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", {
            class: "bonusomat-onboarding-page__title",
            innerHTML: _ctx.title
          }, null, 8, _hoisted_4),
          _createElementVNode("div", {
            class: "bonusomat-onboarding-page__description",
            innerHTML: _ctx.description
          }, null, 8, _hoisted_5)
        ])
      ])
    ])
  ], 2))
}
}

})